export default __webpack_public_path__ + "d8b3a23c53b0d8228c9746e71911f471.ttf";